module.exports = __webpack_public_path__ + "img/40.4.NH3-N.ee7a6a68.png";